import Vue from 'vue'
import VueRouter from 'vue-router';
import Router from 'vue-router';
import Home from "@/views/Home";
import allProducts from "@/views/allProducts";
import services from "@/views/services";
import aboutUs from "@/views/aboutUs";
import vision from "@/views/vision";
import conference from "@/views/conference";
import mission from "@/views/mission";
import contactUs from "@/views/contactUs";
import goTo from 'vuetify/lib/services/goto'
import productDetails from "@/views/Product-details";
import BlogPosts from "@/views/BlogPosts";
import blogPostsDetails from "@/views/BlogPosts-details";
import blogCategories from "@/views/BlogCategories";
import servicesDetails from "@/views/Services-details";
import termsAndConditions from "@/views/TermsAndConditions";
import compare from "@/views/compare";
import photoGallery from "@/views/photoGallery";
import catalog from "@/views/Catalog";
import search from "@/views/search";
import ourcustomers from "@/views/ourcustomers";
import CatalogDetail from "@/views/CatalogDetail";
Vue.use(VueRouter);
export default new Router({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
    routes: [
        {
            path: '/',
            redirect: '/Home',
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/Home",
            component: Home,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/allProducts",
            component: allProducts,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/services",
            component: services,
            meta: {transition: 'fade-in-up'},
        },

        {
            path: "/aboutUs",
            component: aboutUs,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/vision",
            component: vision,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/conference",
            component: conference,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/mission",
            component: mission,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/contactUs",
            component: contactUs,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/productDetails",
            component: productDetails,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/BlogPosts",
            component: BlogPosts,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/blogPostsDetails",
            component: blogPostsDetails,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/blogCategories",
            component: blogCategories,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/servicesDetails",
            component: servicesDetails,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/termsAndConditions",
            component: termsAndConditions,
            meta: {transition: 'fade-in-up'},
        },

        {
            path: "/compare",
            component: compare,
            meta: {transition: 'fade-in-up'},
        },

        {
            path: "/photoGallery",
            component: photoGallery,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/catalog",
            component: catalog,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/catalog",
            component: catalog,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/search",
            component: search,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/CatalogueDetail",
            component: CatalogDetail,
            meta: {transition: 'fade-in-up'},
        },
        {
            path: "/ourcustomers",
            component: ourcustomers,
            meta: {transition: 'fade-in-up'},
        },

    ]
});
